export class Listener {
  onNavigate(callback) {
    this.navigationHandler = () => {
      if (this.lastHash !== window.location.hash) {
        this.lastHash = window.location.hash;
        callback();
      }
    };

    // Polyfill for IE 11
    window.addEventListener('popstate', this.navigationHandler);
    window.addEventListener('hashchange', this.navigationHandler);
  }

  unbind() {
    window.removeEventListener('popstate', this.navigationHandler);
    window.removeEventListener('hashchange', this.navigationHandler);
  }
}
